// Tabs reports the index of the clicked button among the tabs it was given,
// so the page must render, look up clicks and validate the URL against one
// and the same list of visible tabs. Kept free of app imports (userPermissions
// pulls in the store) so it can be tested in isolation.

export const visiblePendingReturnsTabs = (tabs, inspectionTab, { canSee, isPrivileged }) =>
  tabs.filter(tab => canSee(tab.permission)).concat(isPrivileged ? [inspectionTab] : []);

// A bookmarked status may name a tab the user can't see; fall back to the
// first visible one instead of rendering a table without its tab.
export const initialPendingReturnsStatus = (statusFromUrl, visibleTabs) =>
  (visibleTabs.some(tab => tab.id === statusFromUrl) ? statusFromUrl : visibleTabs[0]?.id);
